import React from 'react';
import { Anchor, MapPin, Mail } from 'lucide-react';
import { navLinks } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const id = sectionId.replace('#', '');
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1E2E2A] text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center gap-2 mb-4"
            >
              <Anchor className="w-6 h-6 text-[#5C7A6E]" />
              <span className="font-display text-xl font-normal tracking-wider">
                ANCHOR
              </span>
            </button>
            <p className="text-white/40 text-sm leading-relaxed">
              A private members' work club.<br />
              Golden Triangle, Algarve.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-medium text-white/60 uppercase tracking-widest mb-4">Navigate</h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/40 hover:text-white/70 text-sm transition-colors duration-300"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-medium text-white/60 uppercase tracking-widest mb-4">Contact</h4>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-white/40 text-sm">
                <MapPin className="w-4 h-4" />
                <span>Golden Triangle, Algarve</span>
              </div>
              <a 
                href="mailto:members@anchoralgarve.com"
                className="flex items-center gap-2 text-white/40 hover:text-white/70 text-sm transition-colors duration-300"
              >
                <Mail className="w-4 h-4" />
                <span>members@anchoralgarve.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/30 text-xs tracking-wide">
              {currentYear} ANCHOR. All rights reserved.
            </p>
            <p className="text-white/30 text-xs tracking-wide">
              A private members' work club. Access is limited.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
